import { render, staticRenderFns } from "./Login.ForgotPassword.vue?vue&type=template&id=376524f4&scoped=true"
import script from "./Login.ForgotPassword.vue?vue&type=script&lang=js"
export * from "./Login.ForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./Login.ForgotPassword.vue?vue&type=style&index=0&id=376524f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376524f4",
  null
  
)

export default component.exports